<i18n src="../../locales/lang.json"></i18n>

<template>  

    <div class="select_container">
      <select class="form-control select-search" data-fouc v-bind:id="'select_assigned_shift_' +  getId()" v-on:change="onChange">
        <option value="" style="">{{ $store.translate('choose_shift') }}</option>
        <option v-for="shift in shifts" v-bind:value="shift.SiteShiftId">
          {{ shift.Name }}
        </option>
      </select>
    </div>
      
</template>

<script>


  var shifts = [];
  export default {
    name: "shift-select-selector",
    props: {
      loadDataOnInit: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        shifts:[],
      };
    },
    methods: {
      clearFields() {
        $("#select_assigned_shift_" + this.getId()).val('');
        $("#select_assigned_shift_" + this.getId()).trigger('change');
      },      
      fetchReloadData() {
        this.loadShifts();
      },
      selectShift(selected) {        
        $("#select_assigned_shift_" + this.getId()).val(selected);
        $("#select_assigned_shift_" + this.getId()).trigger('change');
      },
      onChange() { 
        this.$emit('event-change-shift', $("#" + 'select_assigned_shift_' + this.getId() + " option:selected").val());//$("#" + 'select_' + this.getId() + " option:selected").text().trim());
      },      
      getId() {
        return this._uid;
      },               
      loadShifts() {
        var thisContext = this;
        try {
          this.shifts = [];
          var url = '/api/Admin/v1/SiteShifts';
          this.$http.get(url).then(response => {
            thisContext.shifts = response.data;

            if (thisContext.shifts !== null && thisContext.shifts.length > 0) {
              thisContext.shifts = thisContext.shifts.sort(function (a, b) {
                var x = a.Name.toLowerCase();
                var y = b.Name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            thisContext.$forceUpdate();
            var v = thisContext.shifts != undefined && thisContext.shifts != null ? thisContext.shifts.length : 0;
            thisContext.$emit('eventdata', v);
          });
        }
        catch (err) {
          alert("err")
        }
      },  
    },
    watch: {      
    },
    mounted() {
      if (this.loadDataOnInit == true) {
        this.loadShifts();
      }
      $("#select_assigned_shift_" + this.getId()).change(this.onChange);
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/shift-select-selector.vue